import { createGlobalStyle } from "styled-components";

import MontserratExtraWoff from "assets/fonts/montserrat-extrabold.woff";
import MontserratExtraWoff2 from "assets/fonts/montserrat-extrabold.woff2";
import MontserratBoldWoff from "assets/fonts/montserrat-bold.woff";
import MontserratBoldWoff2 from "assets/fonts/montserrat-bold.woff2";
import MontserratSemiWoff from "assets/fonts/montserrat-semibold.woff";
import MontserratSemiWoff2 from "assets/fonts/montserrat-semibold.woff2";
import MontserratMediumWoff from "assets/fonts/montserrat-medium.woff";
import MontserratMediumWoff2 from "assets/fonts/montserrat-medium.woff2";
import MontserratRegularWoff from "assets/fonts/montserrat-regular.woff";
import MontserratRegularWoff2 from "assets/fonts/montserrat-regular.woff2";

const GlobalStyles = createGlobalStyle`
@font-face {
  font-family: "Montserrat";
  src: url(${MontserratExtraWoff2}) format("woff2"), url(${MontserratExtraWoff}) format("woff");
  font-weight: 800;
  font-style: normal;
  font-display: swap;
  unicode-range: U+0041-005A, U+0061-007A, U+0030-0039, U+0020-002F, U+003A-0040, U+005B-0060, U+007B-007E; /* 영문 대소문자, 숫자, 특수문자 */
}
@font-face {
  font-family: "Montserrat";
  src: url(${MontserratBoldWoff2}) format("woff2"), url(${MontserratBoldWoff}) format("woff");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
  unicode-range: U+0041-005A, U+0061-007A, U+0030-0039, U+0020-002F, U+003A-0040, U+005B-0060, U+007B-007E; /* 영문 대소문자, 숫자, 특수문자 */
}
@font-face {
  font-family: "Montserrat";
  src: url(${MontserratSemiWoff2}) format("woff2"), url(${MontserratSemiWoff}) format("woff");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
  unicode-range: U+0041-005A, U+0061-007A, U+0030-0039, U+0020-002F, U+003A-0040, U+005B-0060, U+007B-007E; /* 영문 대소문자, 숫자, 특수문자 */
}
@font-face {
  font-family: "Montserrat";
  src: url(${MontserratMediumWoff2}) format("woff2"), url(${MontserratMediumWoff}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
  unicode-range: U+0041-005A, U+0061-007A, U+0030-0039, U+0020-002F, U+003A-0040, U+005B-0060, U+007B-007E; /* 영문 대소문자, 숫자, 특수문자 */
}
@font-face {
  font-family: "Montserrat";
  src: url(${MontserratRegularWoff2}) format("woff2"), url(${MontserratRegularWoff}) format("woff");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
  unicode-range: U+0041-005A, U+0061-007A, U+0030-0039, U+0020-002F, U+003A-0040, U+005B-0060, U+007B-007E; /* 영문 대소문자, 숫자, 특수문자 */
}

* {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  box-sizing: border-box;
}

html {
  font-size: 2.7777777778vw;
  -webkit-font-smoothing: antialiased;
  scroll-behavior: smooth;
  touch-action: manipulation;
  overscroll-behavior: none;
}

body {
   height: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  text-size-adjust: 100%;
  overflow-wrap: break-word;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  letter-spacing: -0.01em;
  scroll-behavior: smooth;
  -webkit-user-select:none;
  -moz-user-select:none;
  -ms-user-select:none;
  user-select:none;
  touch-action: manipulation;
  overscroll-behavior: none;
  
}

body::-webkit-scrollbar {
  display: none;
}

body, button, input, select, table, textarea {
  color: #000;
  font-size: 1.6rem;
  font-family: "Montserrat", "Pretendard", sans-serif;
  font-weight: 400;
}

body, p, h1, h2, h3, h4, h5, h6, ul, ol, li, dl, dt, dd, table, th, td, form, fieldset, legend, input, textarea, button, select, figure {
  margin: 0;
  padding: 0;
}

img {
  max-width: 100%;
  height: auto;
}

ol, ul {
  list-style: none;
}

button, fieldset, iframe, input, select, table, textarea {
  border: 0;
}

button, dialog, input, mark, meter, progress {
  background-color: transparent;
}

button, input, meter, progress, select, textarea {
  -moz-appearance: none;
       appearance: none;
  -webkit-appearance: none;
}

a, button, input, select, textarea, [contenteditable] {
  outline: 0;
}

button, select, input[type=checkbox], input[type=radio] {
  cursor: pointer;
}

input[type=checkbox],
input[type=radio] {
  position: absolute;
  overflow: hidden;
  width: 1px;
  height: 1px;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

address, caption, code, figcaption, em, i {
  font-style: normal;
}

button::-moz-focus-inner, input::-moz-focus-inner {
  padding: 0;
  border: 0;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

iframe {
  overflow: hidden;
}

textarea {
  overflow: auto;
  resize: none;
  box-sizing: content-box;
}

legend {
  height: 0;
  visibility: hidden;
}

button {
  color: inherit;
}

button:disabled, input:disabled {
  cursor: default;
}

a {
  color: inherit;
  text-decoration: none;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}

a:hover {
  text-decoration: none;
}

hr {
  display: none;
}

input {
  -moz-appearance: none;
  appearance: none;
  -webkit-appearance: none;
}

input::-moz-placeholder {
  color: #8f8f8f;
}

input::placeholder {
  color: #8f8f8f;
}

input:-ms-input-placeholder {
  color: #8f8f8f;
}

.g_ir, .page_inquiry .form_area .list_file .btn_delete_file, [class^=c_bottomsheet] .box_header .btn_close, .btn_delete_file {
  display: block;
  overflow: hidden;
  width: 0;
  height: 0;
  font-size: 1px;
  line-height: 1px;
  color: transparent;
}

.document_scroll header::after {
  opacity: 1;
  background-color: #fff;
  background: linear-gradient(180deg, rgb(255, 255, 255) 50%, rgba(255, 255, 255, 0.8) 100%, rgba(255, 255, 255, 0) 100%);
  border-bottom: 1px solid #ececec;
}

html.show_panel {
  overflow: hidden;
}

`;

export default GlobalStyles;
